// extracted by mini-css-extract-plugin
export default {"logo":"classes_logo__E1mH2"};